import axios from 'axios';
import API_BASE_URL from '../config.js';

const getComments = async (event) => {

    const response = await axios.get(`${API_BASE_URL}/comments/`,
    );

    return response.data;

};

export default getComments 
